interface SavedSearchChipsProps {
    savedSearches: string[]
    onSelect: (query: string) => void
    onRemove: (query: string) => void
}

export function SavedSearchChips({ savedSearches, onSelect, onRemove }: SavedSearchChipsProps) {
    if (savedSearches.length === 0) return null

    return (
        <div className="mt-3 flex flex-wrap gap-2">
            {savedSearches.map((search) => (
                <div key={search} className="inline-flex items-center gap-1 rounded-full border border-slate-200 bg-white px-3 py-1 text-sm">
                    <button
                        type="button"
                        className="text-slate-700 hover:underline"
                        onClick={() => onSelect(search)}
                    >
                        {search}
                    </button>
                    <button
                        type="button"
                        className="ml-1 text-slate-400 hover:text-slate-600"
                        onClick={() => onRemove(search)}
                        aria-label="Remove saved search"
                    >
                        ×
                    </button>
                </div>
            ))}
        </div>
    )
}
